var $627fbb16c92fb654$exports = {};
$627fbb16c92fb654$exports = {
    "dismiss": `Revocare`
};


export {$627fbb16c92fb654$exports as default};
//# sourceMappingURL=ro-RO.mjs.map
